import { useState, useCallback } from "react";

/**
 * A simple hook for toggling boolean state
 * @param initialState The initial boolean state
 * @returns A tuple with the state value and a toggle function
 */
export const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(() => {
    setState((prev) => !prev);
  }, []);

  return [state, toggle] as const;
};

export default useToggle; 